import script from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MostaContextMenu.vue?vue&type=style&index=0&id=6c3675c2&lang=scss"

const __exports__ = script;

export default __exports__